import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import TElogo from "../../../assets/images/logopng13.png";
import TElogo from "../../../assets/images/dod_logo.png";
import { login } from "../../../services/apis/AuthService";
import { Toaster } from "../../components/Toaster/Toster";
import BtnLoader from "../../components/Loader/btnLoader";
import connectImg from "../../../assets/images/dod_connect.png";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";

function LoginTriEssense(props) {
  const [email, setEmail] = useState();
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Validation logic
  const validateFields = () => {
    const errorObj = { email: "", password: "" };
    let isError = false;
    if (!email) {
      errorObj.email = "Email is required";
      isError = true;
    }
    if (!password) {
      errorObj.password = "Password is required";
      isError = true;
    }
    setErrors(errorObj);
    return isError;
  };

  // Reset the specific error when the user starts typing
  const handleInputChange = (e, field) => {
    if (field === "email") {
      setEmail(e.target.value);
      if (submitted && errors.email) {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      }
    } else if (field === "password") {
      setPassword(e.target.value);
      if (submitted && errors.password) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    }
  };

  const onLogin = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Validate fields
    if (validateFields()) {
      return;
    }
    setBtnLoading(true);

    try {
      const res = await login(email, password, navigate);
      const stateData = {
        email: email,
        // otp: res?.data?.data?.otp,
      };
      if (res?.status == 200 || res?.status == 201) {
        navigate("/verification", { state: stateData });
      } else {
        console.log("Login not successfully done");
      }
    } catch (error) {
      Toaster.error(error.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="login-mainsection-background">
          <div className="container-fluid">
            <div className="row">
              {/* <div className="d-none d-lg-block col-lg-6 col-md-5 p-0">
              <div className="left-section position-relative overflow-hidden">
                <video
                  className="df-video"
                  height="100vh"
                  autoPlay
                  muted
                  loop
                  controls={false}>
                  <source src={dfVideo} type="video/mp4" />
                </video>
                <div>
                  <h4 className="login-left-section-text">
                    Welcome to <br/> Digital Fusion
                  </h4>
                </div>
              </div>
            </div> */}
              <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
                <div className=" login-right-content-section">
                  <div className="card login-card mb-0 h-auto">
                    <div className="card-body">
                      {/* logo */}
                      <div className="d-flex justify-content-center mb-2">
                        <Link to={"/dashboard"}>
                          <img
                            src={TElogo}
                            alt="logo"
                            style={{ height: "80px", width: "auto" }}
                          />
                        </Link>
                      </div>
                      {/* Tag or intro Line */}
                      <h4 className="login-welcome-text">
                        Welcome back Admin !
                      </h4>
                      <h4 className="mb-2">Sign in to your account</h4>

                      {/* Form */}
                      <form onSubmit={onLogin}>
                        <div className="mb-3">
                          <label className="mb-1 text-dark">
                            <strong>Email</strong>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => handleInputChange(e, "email")}
                            placeholder="Type Your Email Address"
                          />
                          {errors.email && (
                            <div className="text-danger fs-12">
                              {errors.email}
                            </div>
                          )}
                        </div>
                        <div className="mb-2">
                          <label className="mb-1 text-dark">
                            <strong>Password</strong>
                          </label>
                          <div className="position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              value={password}
                              placeholder="Type Your Password"
                              onChange={(e) => handleInputChange(e, "password")}
                            />
                            <span
                              className="user-eyeicon-div"
                              onClick={togglePasswordVisibility}>
                              {showPassword ? (
                                <IoMdEyeOff size={22} />
                              ) : (
                                <IoEye size={22} />
                              )}
                            </span>
                          </div>
                          {errors.password && (
                            <div className="text-danger fs-12">
                              {errors.password}
                            </div>
                          )}
                        </div>

                        <div className="row d-flex justify-content-between mt-0 mb-0">
                          <div className="mb-3">
                            <div className="d-flex justify-content-end form-check custom-checkbox ms-1 ps-0 ">
                              {/* <Link className="text-dark" to="/verification">Verification</Link> */}
                              <Link className="text-dark" to="/forgotpassword">
                                Forgot Password?
                              </Link>
                            </div>
                          </div>
                        </div>
                        {/* <div className="row d-flex justify-content-between mt-4 mb-2">
                          <div className="mb-3">
                            <div className="form-check custom-checkbox ms-1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="basic_checkbox_1"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="basic_checkbox_1">
                                Remember my preference
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn text-white btn-block handle-login-btn"
                          >
                            {btnLoading && <BtnLoader />}
                            {/* Sign In */}
                            <img
                              className="user-login-connect-img"
                              src={connectImg}
                              alt="connect-img"
                            />
                          </button>
                        </div>
                      </form>

                      <div className="text-center my-3">
                        <div className="or-divider">
                          <span className="text-or">OR</span>
                        </div>
                      </div>

                      <div className="d-flex justify-content-between gap-3">
                        <Link className="text-dark" to="/user/login">
                          Sign In as{" "}
                          <span className="admin-staff-text">User</span>
                        </Link>
                        <Link className="text-dark" to="/staff/login">
                          Sign In as{" "}
                          <span className="admin-staff-text">Staff</span>
                        </Link>
                      </div>
                      {/* Button for signup and forgot password */}
                      {/* <div className="new-account mt-3">
                    <p>
                      Don't have an account?{" "}
                      <Link to="/page-register" className="text-primary">
                        Sign up
                      </Link>
                    </p>
                  </div> */}
                    </div>
                  </div>
                </div>
                <div className="bottom-section mt-3 mt-xxl-5">
                  <p className="user-login-bottom-text">
                    D.O.D "Decade od Design" is a registered trademark of Tri
                    Essence. <br />© 2025 Tri Essence
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(LoginTriEssense);
